import { useQuery } from "@tanstack/react-query";
import { api } from "../../libs/axios";

interface GetLimiteResponse {
  limiteDinheiro?: string;
  limiteCartao?: string;
  limiteBilhetesIda?: number;
  limiteBilhetesVolta?: number;
  limiteBilhetesTotal?: number;
  relatorioRepresentanteDataLimite?: string;
}

async function getLimites(): Promise<GetLimiteResponse> {
  const response = await api.get('/limites').then(response => response.data)

  return response;
}

export function useLimites() {
  return useQuery({
    queryKey: ['limites'],
    queryFn: () => getLimites(),
    staleTime: 1,
    gcTime: 1,
    retry: false,
  });
}
